import $ from 'jquery';
import {Component} from '../../../component';

/* global Cookies, __GOOGLE_TRANSLATION_CONFIG__ */
export class LangSwitcher extends Component {

    /**
     * Constructor
     */
    constructor(context) {
        super(context);

        this.langConfig = window.__GOOGLE_TRANSLATION_CONFIG__ || {};
        // The following cookie name is important because it's Google-predefined for the translation engine purpose
        this.cookieName = 'googtrans';
    }

    /**
     * setup
     */
    setup() {
        let existingLangCookieValue = Cookies.get(this.cookieName);
        let langValue = '';

        if (existingLangCookieValue) {
            // 2. If the cookie is defined, extract a language nickname from there.
            const sp = existingLangCookieValue.split('/');
            if (sp.length > 2) {
                langValue = sp[2];
            }
        }

        if (this.langConfig && !langValue) {
            langValue = this.langConfig.defaultLanguage;
        }

        if (langValue) {
            // 4. Set the current language if we have a related decision.
            // setCurrentLanguage(langValue);
            this.setDropdownState(langValue);
        }

        console.log(existingLangCookieValue, langValue, 'existingLanguageCookieValue :: langValue :: currentLangValue');

        // Bind events
        $(document).on('click', '.js-c-lang-switcher-item-btn', this.onSwitchLanguage.bind(this));
    }

    /**
     * @param {object} evt
     */
    onSwitchLanguage(evt) {
        if (evt) {
            evt.preventDefault();
        }

        const lang = $(evt.currentTarget).data('lang') || '';

        this.switchLanguage(lang);
    }

    /**
     * @param {string} lang
     */
    switchLanguage(lang) {
        console.log(lang, 'switchLanguage :: evt :: lang');

        const cookieVal = '/' + this.langConfig.defaultLanguage + '/' + lang;

        Cookies.set(this.cookieName, cookieVal, { path: '/', domain: 'carpartsorder.eu' });
        Cookies.set(this.cookieName, cookieVal, { path: '/', domain: '' });

        this.setDropdownState(lang);

        window.location.reload();
    }

    /**
     * @param {string} lang
     */
    setDropdownState(lang) {
        console.log(lang, 'switchLanguage :: evt :: lang');

        $('.js-c-lang-switcher-item-btn').each(function (i, el) {
            const $el = $(el);
            const $item = $el.closest('.c-lang-switcher-item');

            $item.removeClass('is--selected');

            if ($el.data('lang') === lang) {
                $item.addClass('is--selected');
                $('.js-c-lang-switcher-btn .c-lang-switcher-btn-flag').html($el.find('.c-lang-switcher-item-btn-flag').html());
                $('.js-c-lang-switcher-btn .c-lang-switcher-btn-label').html($el.find('.c-lang-switcher-item-btn-label').html());
            }
        });
    }
}
